import get from 'lodash.get';

import { RESET_STATE } from 'services/auth/constants';

import { DocumentsState, DocumentsActions } from './types';
import { DOCUMENTS_SET, DOCUMENTS_MERGE } from './constants';

const initialState: DocumentsState = {};

export default function documentsReducer(
    state: DocumentsState = initialState,
    action: DocumentsActions
): DocumentsState {
    switch (action.type) {
        case DOCUMENTS_SET:
            return get(action, 'payload', {});
        case DOCUMENTS_MERGE:
            return {
                ...state,
                ...get(action, 'payload', {})
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
